import axios from 'axios';
import getTokenFromCookies from "@/helpers/getTokenFromCookies";
const ProfileService = {};

ProfileService.getProfileInfo = async function () {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };

    const response = await axios(`${axios.defaults.baseURL}/api/v1/profile/info`, {
        headers,
    });

    return { 
        data: response.data.data, 
        status: response.status 
    };
};

ProfileService.changePassword = async function (passwordData) {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };

    const { data } = await axios.post(
        `${axios.defaults.baseURL}/api/v1/profile/change-password`,
        passwordData,
        { headers }
    );

    return data;
};

ProfileService.cancelMembership = async function (reason) {
    const headers = {
        Authorization: `Bearer ${getTokenFromCookies()}`,
    };

    const { data } = await axios.post(
        `${axios.defaults.baseURL}/api/v1/profile/unsubscribe`,
        reason,
        { headers }
    );

    return data;
};

export default ProfileService;
